module.exports = __webpack_public_path__ + "img/Importspark-banner.ecdf224e.png";